<script lang="ts" setup>
defineProps<{
	link: App.Data.FileData
}>()
</script>

<template>
	<i-jstiming-pdf v-if="link.type === 'pdf'" />
	<i-jstiming-doc v-else-if="link.type === 'word'" />
	<i-jstiming-xls v-else-if="link.type === 'excel'" />
	<i-jstiming-link v-else />
</template>
